import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BrifingFormService } from 'src/@core/services/briefing-form/brifing-form.service';
import { BriefingFormValuesService } from 'src/@core/services/briefingForm-values/briefing-form-values.service';

@Component({
  selector: 'hour4u-admin-briefing-details',
  templateUrl: './briefing-details.component.html',
  styleUrls: ['./briefing-details.component.scss']
})
export class BriefingDetailsComponent implements OnInit {
  briefingForm: FormGroup;
  sectionExist: boolean = false;
  sections: any[] = [];
  fields: any[] = [];
  currentSectionIndex: number = 0;
  showSummary: boolean = false;
  isLoading: boolean = false;
  id: string = '';
  loaderColor: string;
  mode = 'indeterminate';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private briefingFormService: BrifingFormService,
    private briefingFormValueService: BriefingFormValuesService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const id = localStorage.getItem("form");
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id'); // Get the id from the URL
      if (this.id) {
        this.loadBriefingDetails(this.id); // Load details based on id
        this.initForm();
      }
    });
  }

  // get data by formid
  loadBriefingDetails(id: string) {
    this.briefingFormService.getBriefingFormById(id).subscribe((res) => {
      console.log("$$$$$$$4444", res)
      if (res.sections && res.sections.length > 0) {
        this.sectionExist = true;
        this.sections = res.sections;
        this.initForm();
      } else {
        this.fields = res.fields;
        this.initForm();
      }
    });
  }

  // initialize form
  initForm() {
    let group: any = {};

    if (this.sectionExist) {
      this.sections.forEach((section) => {
        section.fields.forEach((field) => {
          group[field.fieldDBName] = field.required ? new FormControl('', Validators.required) : new FormControl('');
        });
      });
    } else {
      this.fields.forEach((field) => {
        group[field.fieldDBName] = field.required ? new FormControl('', Validators.required) : new FormControl('');
      });
    }

    this.briefingForm = this.fb.group(group);
  }

  //check all details fill of current section
  isCurrentSectionValid(): boolean {
    const currentSection = this.sections[this.currentSectionIndex];
    if (currentSection) {
      return currentSection.fields.every(field => this.briefingForm.get(field.fieldDBName).valid);
    }
    return false;
  }

  // navigate to previous section
  previousSection() {
    if (this.currentSectionIndex > 0) {
      this.currentSectionIndex--;
    }
    else {
      this.previous();
    }
  }

  // navigate to next section
  nextSection() {
    if (this.sectionExist && this.currentSectionIndex < this.sections.length - 1) {
      this.currentSectionIndex++;
    } else {
      this.showSummary = true;
    }
  }

  // navigate previous page
  previous() {
    // this.router.navigateByUrl(`briefing/about/${this.id}`);
  }

  onFileSelected(event: Event, field: any) {
    if (field) {
      field.value = []; // Initialize the value array
    }

    this.isLoading = true;

    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const fileNames = Array.from(inputElement.files).map(file => file.name);

      if (field) {
        field.value = fileNames; // Assign the file names to the field's value
        console.log("val", field.value);

        // Update the form control value if needed
        const formControl = this.briefingForm.get(field.fieldDBName);
        if (formControl) {
          formControl.setValue(fileNames); // You can set an array if your form control can handle it
        }
      }

      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
  }

  deleteSelectedFile(index: number, fileNames: string[], field: any) {
    if (fileNames) {
      fileNames.splice(index, 1); // Remove the file name from the list
      const formControl = this.briefingForm.get(field.fieldDBName);
      if (formControl) {
        formControl.setValue(fileNames); // Update the form control value
      }
    }
  }

  onSubmit() {
    if (this.briefingForm.valid) {
      // const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');

      // Prepare the payload based on whether sections exist
      const payload: any = {
        formId: this.id,
        fillerDetails: {
          // name: userDetails.name,
          // companyName: userDetails.companyName,
          // mobile: userDetails.mobile,
          // email: userDetails.email
        }
      };

      // Only add sections to the payload if they exist
      if (this.sectionExist) {
        payload.sections = this.prepareSectionForSubmission();
        this.briefingFormValueService.submitBriefingFormValuesWithSection(payload).subscribe((res) => {
        });
      } else {
        payload.fieldValues = this.prepareFieldsForSubmission();
        this.briefingFormValueService.submitBriefingFormValuesWithOutSection(payload).subscribe((res) => {
        });
      }
      this.router.navigateByUrl(`briefing/${this.id}`);
    }
  }

  // payload for sections
  prepareSectionForSubmission() {
    return this.sections.map(section => ({
      name: section.name,
      fieldValues: section.fields.map(field => {
        // Get the form control value
        const fieldValue = this.briefingForm.get(field.fieldDBName).value;

        // Format the date if necessary (in case it is not in yyyy-mm-dd format)
        const formattedValue = field.fieldDBType === 'DATE' ? this.formatDate(fieldValue) : fieldValue;

        return {
          name: field.name,
          type: field.type,
          options: field.options,
          value: formattedValue,
          required: field.required,
          fieldDBType: field.fieldDBType,
          fieldDBName: field.fieldDBName
        };
      })
    }));
  }

  // Helper function to format date as yyyy-mm-dd
  formatDate(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  // prepare for fields
  prepareFieldsForSubmission() {
    return this.fields.map(field => {
      const fieldValue = this.briefingForm.get(field.fieldDBName).value;

      // Format the date if necessary (in case it is not in yyyy-mm-dd format)
      const formattedValue = field.fieldDBType === 'DATE' ? this.formatDate(fieldValue) : fieldValue;

      return {
        name: field.name,
        type: field.fieldDBType,
        options: field.options,
        value: formattedValue,
        required: field.required,
        fieldDBType: field.fieldDBType,
        fieldDBName: field.fieldDBName
      };
    });
  }
}